import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";

import { WSEmptyState } from "@wingspanhq/fe-component-library";
import { useBrowserPageTitle } from "../../components/BrowserPageTitle/BrowserPageTitle";
import { useIsEngagementsActive } from "../../shared/hooks/useIsEngagementsActive";
import { RouteArchivedPayees } from "./routes/RouteArchivedPayees";
import { RoutePayeesDashboard } from "./routes/RouteDashboard";
import { RouteEditPayeeInformation } from "./routes/RouteEditPayeeTaxInfo";
import { RoutePayeeDetails } from "./routes/RoutePayeeDetails";
import { RoutePayeeEngagementDetails } from "./routes/RoutePayeeDetails/RoutePayeeEngagementDetails";
import { RoutePayeeEngagementHistory } from "./routes/RoutePayeeDetails/RoutePayeeEngagementDetails/RoutePayeeEngagementHistory";
import { RoutePayeeHistory } from "./routes/RoutePayeeDetails/RoutePayeeHistory";
import { RouteRequirementDetails } from "./routes/RoutePayeeDetails/RouteRequirementDetails";
import { RoutePayeesSearch } from "./routes/RoutePayeesSearch/RoutePayeesSearch";
import { RouteRequirements } from "./routes/RouteRequirements";
import {
  PAYEES_ALL_PATH,
  PAYEES_ARCHIVED_PATH,
  PAYEES_DETAILS_EDIT_INFORMATION_ROUTE,
  PAYEES_DETAILS_ENGAGEMENT_DETAILS_ROUTE,
  PAYEES_DETAILS_ENGAGEMENT_HISTORY_ROUTE,
  PAYEES_DETAILS_HISTORY_ROUTE,
  PAYEES_DETAILS_REQUIREMENTS_ROUTE,
  PAYEES_DETAILS_ROUTE,
  PAYEES_ELIGIBLE_PATH,
  PAYEES_ENGAGEMENTS_DETAILS_PATH,
  PAYEES_ENGAGEMENTS_LIST_PATH,
  PAYEES_GROUPS_LIST_PATH,
  PAYEES_INELIGIBLE_PATH,
  PAYEES_NOT_SIGNED_UP_PATH,
  PAYEES_REQUIREMENT_DETAILS_ROUTE,
  PAYEES_REQUIREMENTS_PATH,
  PAYEES_ROOT_PATH,
  PAYEES_SEARCH_PATH
} from "./utils";

export const PayeesIndex: React.FC = () => {
  useBrowserPageTitle("Contractors");
  const isNewEngagements = useIsEngagementsActive();

  return (
    <Switch>
      <Route
        path={[
          PAYEES_ALL_PATH,
          PAYEES_INELIGIBLE_PATH,
          PAYEES_ELIGIBLE_PATH,
          PAYEES_ARCHIVED_PATH,
          PAYEES_NOT_SIGNED_UP_PATH
        ]}
        component={RoutePayeesDashboard}
      />

      <Route
        path={PAYEES_REQUIREMENT_DETAILS_ROUTE}
        component={RouteRequirementDetails}
      />
      <Route path={PAYEES_SEARCH_PATH} component={RoutePayeesSearch} />
      {isNewEngagements
        ? [
            <Route
              key={PAYEES_ENGAGEMENTS_LIST_PATH}
              path={PAYEES_ENGAGEMENTS_LIST_PATH}
              component={RoutePayeesDashboard}
            />,
            <Route
              key={PAYEES_GROUPS_LIST_PATH}
              path={PAYEES_GROUPS_LIST_PATH}
              component={() => (
                <WSEmptyState
                  type="people"
                  size="M"
                  theme="garnet"
                  title="You have no access to groups"
                  description="Contact your administrator to request access"
                />
              )}
            />
          ]
        : [
            <Route
              key={PAYEES_GROUPS_LIST_PATH}
              path={PAYEES_GROUPS_LIST_PATH}
              component={RoutePayeesDashboard}
            />,
            <Route
              key={PAYEES_ENGAGEMENTS_LIST_PATH}
              path={PAYEES_ENGAGEMENTS_LIST_PATH}
              component={() => (
                <WSEmptyState
                  type="people"
                  size="M"
                  theme="garnet"
                  title="You have no access to engagements"
                  description="Contact your administrator to request access"
                />
              )}
            />
          ]}
      <Route
        path={
          isNewEngagements
            ? PAYEES_ENGAGEMENTS_LIST_PATH
            : PAYEES_GROUPS_LIST_PATH
        }
        component={RoutePayeesDashboard}
      />
      <Route path={PAYEES_REQUIREMENTS_PATH} component={RouteRequirements} />
      <Route
        path={PAYEES_DETAILS_REQUIREMENTS_ROUTE}
        component={RoutePayeeDetails}
      />
      <Route
        path={PAYEES_DETAILS_EDIT_INFORMATION_ROUTE}
        component={RouteEditPayeeInformation}
      />

      <Route
        path={PAYEES_DETAILS_ENGAGEMENT_HISTORY_ROUTE}
        component={RoutePayeeEngagementHistory}
      />
      <Route
        path={PAYEES_DETAILS_ENGAGEMENT_DETAILS_ROUTE}
        component={RoutePayeeEngagementDetails}
      />
      <Route
        path={PAYEES_DETAILS_HISTORY_ROUTE}
        component={RoutePayeeHistory}
      />
      <Route path={PAYEES_DETAILS_ROUTE} component={RoutePayeeDetails} />
      <Route path={PAYEES_ROOT_PATH} component={RoutePayeesDashboard} />
      <Redirect from="*" to={PAYEES_ROOT_PATH} />
    </Switch>
  );
};
